import React from "react";
import { ChevronRightIcon, HomeIcon } from "@heroicons/react/solid";
import Link from "next/link";

const pages = [
  { name: "IAS Study Material ", href: "#", current: false },
  { name: "IAS Toppers Samanya ", href: "#", current: true },
];
const ProductBreadNav = ({ product }) => {
  return (
    <nav className="hidden md:flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center">
        <li className="mr-3">
          <div>
            <Link href="/">
              <HomeIcon
                className="cursor-pointer flex-shrink-0 h-5 w-5 text-gray-400 hover:text-gray-500"
                aria-hidden="true"
              />
            </Link>
          </div>
        </li>
        {product.category ? (
          <li className="mr-3">
            <div className="flex items-center">
              <ChevronRightIcon
                className="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              {/* <Link  href={`/categories/${product.category.id}`}> */}
              <a className="text-sm font-medium text-gray-500 hover:text-gray-700">
                {product.category.name}
              </a>
              {/* </Link> */}
            </div>
          </li>
        ) : (
          ""
        )}

        <li>
          <div className="flex items-center">
            <ChevronRightIcon
              className="flex-shrink-0 h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
            <a className="ml-3 capitalize text-sm font-medium text-gray-500 hover:text-gray-700">
              {product.name}
            </a>
          </div>
        </li>
      </ol>
    </nav>
  );
};

const ProductBreadNavMemo = React.memo(
  ProductBreadNav,
  (preProps, nextProps) => {
    if (JSON.stringify(preProps.product) !== JSON.stringify(nextProps.product))
      return true;
    return false;
  }
);

export default ProductBreadNav;
